import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDatepickerInput } from '@angular/material/datepicker';

@Component({
  selector: 'cosmos-date-picker',
  templateUrl: './custom-date-picker.component.html',
  styleUrls: ['./custom-date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CustomDatePickerComponent,
    },
  ],
})
export class CustomDatePickerComponent implements ControlValueAccessor, AfterViewInit {
  @ViewChild(MatDatepickerInput) private _valueAccessor: any;

  private _value: any;
  private _formControlChanged: any;
  private _formControlTouched: any;

  public constructor() { }

  public ngAfterViewInit(): void {
    this._valueAccessor.registerOnChange(this._formControlChanged);
    this._valueAccessor.registerOnTouched(this._formControlTouched);
    this._valueAccessor.writeValue(this._value);
  }

  public writeValue(obj: any): void {
    this._value = obj;
  }

  public registerOnChange(fn: any): void {
    this._formControlChanged = fn;
  }

  public registerOnTouched(fn: any): void {
    this._formControlTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this._valueAccessor.setDisabledState?.(isDisabled);
  }
}
